import React, { useState, useEffect } from "react";
import { Row, Col, Form, Dropdown, Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import Axios from "axios";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as NewEventStyles from "../styles/event";

function Event(props) {
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();

    const [times, setTimes] = useState({ startTimes: [], endTimes: [] });

    const [details, setDetails] = useState({
        title: "",
        titleError: false,
        description: "",
        date: moment().toDate(),
        endDate: moment().toDate(),
        allDay: false,
        repeat: false,
        repeatType: "single",
        repeatTypeText: "",
        repwom_week: 1,
        repwom_day: "sun",
        startTime: "08:00",
        endTime: ""
    });

    const repeatTexts = [
        { repeat: "single", text: "No Repeat" },
        { repeat: "daily", text: "Daily" },
        { repeat: "weekly", text: "Weekly" },
        { repeat: "wom", text: "Week Of Month" },
        { repeat: "dom", text: "Day Of Month" }
    ];

    const dayTexts = [
        { day: "sun", text: "Sunday" },
        { day: "mon", text: "Monday" },
        { day: "tue", text: "Tueday" },
        { day: "wed", text: "Wednesday" },
        { day: "thu", text: "Thursday" },
        { day: "fri", text: "Friday" },
        { day: "sat", text: "Saturday" }
    ];

    const weekTexts = [
        { week: 1, text: "1st" },
        { week: 2, text: "2nd" },
        { week: 3, text: "3rd" },
        { week: 4, text: "4th" }
    ];

    const [modal, setModal] = useState({
        header: "",
        open: false,
        message: ""
    });

    function handleCloseModal() {
        setModal((prevState) => {
            return { ...prevState, open: false };
        });
        navigate(-1);
    }

    const [modalYN, setModalYN] = useState({
        open: false,
        heading: "",
        message: "",
        acceptFunction: "",
        acceptName: "",
        showAccept: false,
        cancelName: "",
        showCancel: false
    });

    function handleModalYNClose() {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        if (props.modify) {
            dispatch(GS_navSettingsActions.UpdateTitle("Calendar - Modify Event"));
        } else {
            dispatch(GS_navSettingsActions.UpdateTitle("Calendar - New Event"));
        }
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("Calendar"));

        const startTimeSlots = [];
        let time = moment().startOf("day");
        const lastTime = moment().endOf("day");
        while (time.isBefore(lastTime)) {
            startTimeSlots.push(time.format("HH:mm"));
            time.add(30, "m");
        }

        const endTimeSlots = [];
        const startTime = moment(details.startTime, "HH:mm");
        startTime.add(30, "m");
        const endTime = moment(startTime);

        while (startTime.isBefore(lastTime)) {
            endTimeSlots.push(startTime.format("HH:mm"));
            startTime.add(30, "m");
        }

        setTimes({ startTimes: startTimeSlots, endTimes: endTimeSlots });

        setDetails((prevState) => {
            return { ...prevState, endTime: endTime.format("HH:mm") };
        });
        modifyLoad();
    }, []);

    function modifyLoad() {
        if (props.modify) {
            const data = { id: params.id };

            Axios.post("/pods/calendar/getSingleEvent", data)
                .then((res) => {
                    const data = res.data;
                    console.log(data);
                    if (data.error == "null") {
                        const event = data.event;
                        setDetails((prevState) => {
                            return {
                                ...prevState,
                                title: event.title,
                                date: moment(event.startDate, "DD/MM/YYYY").toDate(),
                                endDate: moment(event.endDate, "DD/MM/YYYY").toDate(),
                                description: event.description,
                                allDay: event.timeType == "allDay",
                                startTime: event.timeType == "setTimes" && event.startTime,
                                endTime: event.timeType == "setTimes" && event.endTime,
                                repeatType: event.repeatType,
                                repwom_day: event.wom_day,
                                repwom_week: event.wom_week
                            };
                        });

                        buildEndTimes(event.startTime);
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    function handleDateChange(date) {
        const values = { ...details.values };
        console.log(date);

        values.date = date;

        setDetails((prevState) => {
            return { ...prevState, ...values };
        });
    }

    function handleUntilDateChange(date) {
        const values = { ...details.values };

        values.endDate = date;

        setDetails((prevState) => {
            return { ...prevState, ...values };
        });
    }

    function handleCheck(event) {
        const { name, checked } = event.target;

        setDetails((prevState) => {
            return { ...prevState, [name]: checked };
        });
    }

    function handleChangeText(event) {
        const { name, value } = event.target;

        setDetails((prevState) => {
            return { ...prevState, [name]: value };
        });
    }

    function handleStartTimeSelect(time) {
        buildEndTimes(time);
        const endTime = moment(time, "HH:mm").add(30, "m");

        setDetails((prevState) => {
            return { ...prevState, startTime: time, endTime: endTime.format("HH:mm") };
        });
    }

    function buildEndTimes(time) {
        const endTime = moment(time, "HH:mm").add(30, "m");
        const lastTime = moment().endOf("day");
        const endTimeSlots = [];
        while (endTime.isBefore(lastTime)) {
            endTimeSlots.push(endTime.format("HH:mm"));
            endTime.add(30, "m");
        }

        setTimes((prevState) => {
            return { ...prevState, endTimes: endTimeSlots };
        });
    }

    function handleEndTimeSelect(time) {
        setDetails((prevState) => {
            return { ...prevState, endTime: time };
        });
    }

    function handleCreateEvent() {
        if (details.title == "") {
            setDetails((prevState) => {
                return { ...prevState, titleError: true };
            });
        } else {
            let timeType = "";
            if (details.allDay) {
                timeType = "allDay";
            } else {
                timeType = "setTimes";
            }

            const data = {
                title: details.title,
                description: details.description,
                startDate: formatDate(details.date),
                endDate: formatDate(details.endDate),
                timeType: timeType,
                startTime: details.allDay ? "---" : details.startTime,
                endTime: details.allDay ? "---" : details.endTime,
                repeatType: details.repeatType,
                wom_week: details.repwom_week.toString(),
                wom_day: details.repwom_day.toString()
            };
            Axios.post("/pods/calendar/submitNewEvent", data)
                .then((res) => {
                    const data = res.data;
                    if (data.error == "null") {
                        setModal({ header: "Calendar", message: data.message, open: true });
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    function handleUpdateClick() {
        if (details.title == "") {
            setDetails((prevState) => {
                return { ...prevState, titleError: true };
            });
        } else {
            let timeType = "";
            if (details.allDay) {
                timeType = "allDay";
            } else {
                timeType = "setTimes";
            }

            const data = {
                id: params.id,
                title: details.title,
                description: details.description,
                startDate: formatDate(details.date),
                endDate: formatDate(details.endDate),
                timeType: timeType,
                startTime: details.allDay ? "---" : details.startTime,
                endTime: details.allDay ? "---" : details.endTime,
                repeatType: details.repeatType,
                wom_week: details.repwom_week.toString(),
                wom_day: details.repwom_day.toString()
            };
            Axios.post("/pods/calendar/updateEvent", data)
                .then((res) => {
                    const data = res.data;
                    if (data.error == "null") {
                        setModal({ header: "Calendar", message: data.message, open: true });
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    function formatDate(date) {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    function handleTitleOnBlur() {
        if (details.title != "") {
            setDetails((prevState) => {
                return { ...prevState, titleError: false };
            });
        }
    }

    function handleChangeRepeatType(type) {
        setDetails((prevState) => {
            return { ...prevState, repeatType: type };
        });

        if (type == "wom") {
            //get the first day of the month
            const startDate = moment(details.date, "DD/MM/YYYY");
            const firstString = moment(`01/${startDate.format("MM")}/${startDate.format("YYYY")}`, "DD/MM/YYYY").toDate();
            let first = moment(firstString);

            //get the last day of the moment
            const last = moment(first);
            last.add(1, "M");
            last.subtract(1, "d");

            const dayName = startDate.format("ddd");
            let weeks = 0;
            while (first.isSameOrBefore(startDate)) {
                if (first.format("ddd") == dayName) {
                    console.log(first.format("DD/MM/YYYY"));
                    weeks++;
                }
                first.add(1, "d");
            }

            setDetails((prevState) => {
                return { ...prevState, repwom_day: dayName.toLowerCase(), repwom_week: weeks };
            });
        }
    }

    function wom_handleChangeWeek(week) {
        setDetails((prevState) => {
            return { ...prevState, repwom_week: week };
        });
    }

    function wom_handleChangeDay(day) {
        setDetails((prevState) => {
            return { ...prevState, repwom_day: day };
        });
    }

    function handleDeleteClick(uuid) {
        setModalYN({
            heading: "Delete Event",
            message: "Are you sure you want to delete this event?",
            showAccept: true,
            acceptName: "Yes",
            acceptFunction: acceptDelete.bind(this, uuid),
            showCancel: true,
            cancelName: "No",
            open: true
        });
    }

    function acceptDelete(uuid) {
        const data = { uuid: uuid };
        Axios.post("/pods/calendar/deleteEvent", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    navigate(-1);
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={NewEventStyles.body}>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label style={NewEventStyles.formTitles}>Title:</Form.Label>
                        <Form.Control
                            isInvalid={details.titleError}
                            type="text"
                            name="title"
                            value={details.title}
                            onChange={handleChangeText}
                            onBlur={handleTitleOnBlur}
                        />
                        <Form.Control.Feedback type="invalid">Please enter a title</Form.Control.Feedback>
                    </Form.Group>
                    <br />
                    <Form.Group>
                        <Form.Label style={NewEventStyles.formTitles}>Description:</Form.Label>
                        <Form.Control as="textarea" rows={5} name="description" value={details.description} onChange={handleChangeText} />
                    </Form.Group>
                </Col>
                <Col>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label style={NewEventStyles.formTitles}>Date:</Form.Label> <br />
                                <DatePicker dateFormat="dd/MM/yyyy" selected={details.date} onChange={(date: Date) => handleDateChange(date)} />
                            </Form.Group>
                        </Col>
                        <Col style={NewEventStyles.columnRight}>
                            {props.modify && <Button onClick={handleDeleteClick.bind(this, params.id)}>Delete</Button>}
                        </Col>
                    </Row>
                    <br />
                    <Form.Group>
                        <Form.Label style={NewEventStyles.formTitles}>Time:</Form.Label> <br />
                        <Form.Check type="checkbox" label="All Day" name="allDay" checked={details.allDay} onChange={handleCheck} />
                    </Form.Group>
                    <Form.Group>
                        <div style={!details.allDay ? NewEventStyles.show : NewEventStyles.hidden}>
                            <Row>
                                <Col sm={2}>
                                    <Form.Label style={NewEventStyles.formDropdownTitle}>Start:</Form.Label>
                                </Col>
                                <Col>
                                    <Dropdown>
                                        <Dropdown.Toggle>{details.startTime}</Dropdown.Toggle>
                                        <Dropdown.Menu style={NewEventStyles.dropdownMenu}>
                                            {times.startTimes.map((time, index) => {
                                                return (
                                                    <Dropdown.Item key={index} onClick={handleStartTimeSelect.bind(this, time)}>
                                                        {time}
                                                    </Dropdown.Item>
                                                );
                                            })}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                                <Col sm={2}>
                                    <Form.Label style={NewEventStyles.formDropdownTitle}>End:</Form.Label>
                                </Col>
                                <Col>
                                    <Dropdown>
                                        <Dropdown.Toggle>{details.endTime}</Dropdown.Toggle>
                                        <Dropdown.Menu style={NewEventStyles.dropdownMenu}>
                                            {times.endTimes.map((time, index) => {
                                                return (
                                                    <Dropdown.Item key={index} onClick={handleEndTimeSelect.bind(this, time)}>
                                                        {time}
                                                    </Dropdown.Item>
                                                );
                                            })}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                            </Row>
                        </div>
                    </Form.Group>
                    <br />
                    <Row>
                        <Col sm={3} style={NewEventStyles.repeatTitles}>
                            Repeat:
                        </Col>
                        <Col>
                            <Dropdown>
                                <Dropdown.Toggle>{repeatTexts.find((rep) => rep.repeat == details.repeatType).text}</Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={handleChangeRepeatType.bind(this, "single")}>No Repeat</Dropdown.Item>
                                    <Dropdown.Item onClick={handleChangeRepeatType.bind(this, "daily")}>Daily</Dropdown.Item>
                                    <Dropdown.Item onClick={handleChangeRepeatType.bind(this, "weekly")}>Weekly</Dropdown.Item>
                                    <Dropdown.Item onClick={handleChangeRepeatType.bind(this, "wom")}>Week Of Month</Dropdown.Item>
                                    <Dropdown.Item onClick={handleChangeRepeatType.bind(this, "dom")}>Day Of Month</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    </Row>
                    {details.repeatType == "wom" && (
                        <div>
                            <Row>
                                <Col sm={3}>
                                    <Dropdown>
                                        <Dropdown.Toggle>{weekTexts.find((wek) => wek.week == details.repwom_week).text}</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={wom_handleChangeWeek.bind(this, 1)}>1st</Dropdown.Item>
                                            <Dropdown.Item onClick={wom_handleChangeWeek.bind(this, 2)}>2nd</Dropdown.Item>
                                            <Dropdown.Item onClick={wom_handleChangeWeek.bind(this, 3)}>3rd</Dropdown.Item>
                                            <Dropdown.Item onClick={wom_handleChangeWeek.bind(this, 4)}>4th</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                                <Col sm={4}>
                                    <Dropdown>
                                        <Dropdown.Toggle>{dayTexts.find((da) => da.day == details.repwom_day).text}</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={wom_handleChangeDay.bind(this, "sun")}>Sunday</Dropdown.Item>
                                            <Dropdown.Item onClick={wom_handleChangeDay.bind(this, "mon")}>Monday</Dropdown.Item>
                                            <Dropdown.Item onClick={wom_handleChangeDay.bind(this, "tue")}>Tuesday</Dropdown.Item>
                                            <Dropdown.Item onClick={wom_handleChangeDay.bind(this, "wed")}>Wednesday</Dropdown.Item>
                                            <Dropdown.Item onClick={wom_handleChangeDay.bind(this, "thu")}>Thursday</Dropdown.Item>
                                            <Dropdown.Item onClick={wom_handleChangeDay.bind(this, "fri")}>Friday</Dropdown.Item>
                                            <Dropdown.Item onClick={wom_handleChangeDay.bind(this, "sat")}>Saturday</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                                <Col style={NewEventStyles.repeatTitles}>Of every month</Col>
                            </Row>
                        </div>
                    )}
                    {details.repeatType != "single" && (
                        <div>
                            <br />
                            <Row>
                                <Col sm={3} style={NewEventStyles.repeatTitles}>
                                    End Date:
                                </Col>
                                <Col>
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={details.endDate}
                                        onChange={(date: Date) => handleUntilDateChange(date)}
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}
                    <br />
                    {props.modify ? <Button onClick={handleUpdateClick}>Update</Button> : <Button onClick={handleCreateEvent}>Create</Button>}
                </Col>
            </Row>
            <Modal show={modal.open} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modal.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modal.message}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={modalYN.open} onHide={handleModalYNClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalYN.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalYN.message}</Modal.Body>
                <Modal.Footer>
                    {modalYN.showAccept ? (
                        <div>
                            <Button variant="primary" onClick={modalYN.acceptFunction}>
                                {modalYN.acceptName}
                            </Button>
                        </div>
                    ) : null}
                    {modalYN.showCancel ? (
                        <div>
                            <Button variant="primary" onClick={handleModalYNClose}>
                                {modalYN.cancelName}
                            </Button>
                        </div>
                    ) : null}
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Event;
